var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/folder/solid-open",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 5.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0.5 C8.35545245,0.5 8.90513217,0.893571006 9.64084848,1.86767045 L9.64084848,1.86767045 L10.8734666,3.5 L20.75,3.5 C21.9926407,3.5 23,4.50735931 23,5.75 L23,5.75 L22.999,7.249 L7.879,7.24998405 C6.87675701,7.24998405 5.99538167,7.91304834 5.71741968,8.876 L2.861,21.5 L2.447,21.5 C2.39501935,21.5 2.3442738,21.4947119 2.29527196,21.4846444 L2.22314057,21.4660221 C2.19244608,21.4631558 2.16169586,21.4597053 2.13090226,21.4556622 L2.13090226,21.4556622 L1.96827699,21.4287804 C0.843657986,21.2040832 0.0161192942,20.221412 -5.5067062e-14,19.05 L-5.5067062e-14,19.05 L-5.5067062e-14,2.75 C-5.5067062e-14,1.50735931 1.00735931,0.5 2.25,0.5 L2.25,0.5 Z M24.4282073,8.74724546 C24.4189922,9.42873412 24.3848053,10.275436 24.2579874,10.7500852 L24.2579874,10.7500852 L22.224742,19.829 C21.9622783,20.8145883 21.069679,21.5003508 20.05,21.5 L20.05,21.5 L4.398,21.5 L7.16952547,9.2494403 C7.25124012,8.970996 7.54501931,8.74998405 7.879,8.74998405 Z",
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.a2fda4dd086552be8de5865110315289.svg";
export { ForwardRef as ReactComponent };